export default "__VITE_ASSET__DktHd7YV__"